import { HeaderBurgerButton } from "@globalgiving/components"
import { FC, useEffect, useState } from "react"
import { Outlet, useLocation } from "react-router"
import { Footer } from "~/components/Footer"
import { Header } from "~/components/Header"
import { NavigationDrawer } from "~/components/NavigationDrawer"
import { config } from "~/config"
import { useAuthActions, useAuthState } from "~/context/auth"
import { useDocumentTitle } from "~/hooks"

import styles from "./App.module.scss"
import { hasAdminRole, SCROLL_ANCHOR_PAGE_WRAPPER } from "./utils"

interface AppProps {
  showNavigation?: boolean
}

const App: FC<AppProps> = ({ showNavigation = true }) => {
  const { user } = useAuthState()
  const { logout } = useAuthActions()

  const [isNavigationShown, setIsNavigationShown] = useState(false)

  const { pathname } = useLocation()
  const title = useDocumentTitle(pathname)

  useEffect(() => {
    document.title = `${title} ${config.documentTitleEnding}`.trim()
  }, [title])

  const userFullName = user ? `${user.firstname} ${user.lastname}`.trim() : ""
  const isAdmin = hasAdminRole(user)

  return (
    <div className={styles.app_wrapper}>
      {showNavigation && (
        <div className={`${styles.navigation_wrapper} ${isNavigationShown && styles.active}`}>
          <NavigationDrawer close={() => setIsNavigationShown(false)} />
        </div>
      )}
      {/* Main content wrapper - this is the scrollable container used for scroll-to-top functionality */}
      <div className={styles.content_wrapper} id={SCROLL_ANCHOR_PAGE_WRAPPER}>
        <div className={styles.header_wrapper}>
          <Header
            isAdmin={isAdmin}
            logout={logout}
            userEmail={user?.email}
            userFullName={userFullName}
            burgerButton={
              showNavigation ? <HeaderBurgerButton onClick={() => setIsNavigationShown(true)} /> : undefined
            }
          />
        </div>
        <div className={`${styles.scrollable_container} ${isNavigationShown && styles.active_navigation}`}>
          <div className={styles.outlet_wrapper}>
            <Outlet />
          </div>
          <Footer />
        </div>
      </div>
    </div>
  )
}

export default App
